export default "__VITE_ASSET__Bf0etQF1__"